import React from 'react';
import styled from 'styled-components';
import { StaticImage } from 'gatsby-plugin-image';
import { CtaLink, CtaOutboundLink } from './cta';
import Modal from './modal';

const ModalIntro = styled.div`
  display: grid;
  grid-auto-rows: auto;
  grid-template-columns: 1fr;
  grid-gap: ${(props) => props.theme.grid.gap};
  align-items: center;
  padding-bottom: 2rem;
  @media all and (min-width: ${(props) => props.theme.breakingpoints.lg}) {
    grid-template-columns: 1fr 2fr;
  }
  .paul {
    display: none;
    @media all and (min-width: ${(props) => props.theme.breakingpoints.lg}) {
      display: block;
    }
  }

  {/* Only one child, don't grid */}
  *:last-child:first-child {
    grid-column: 1 / -1;
  }
`;

const CtaWrapper = styled.div`
  display: grid;
  grid-auto-rows: auto;
  grid-template-columns: 1fr;
  grid-gap: ${(props) => props.theme.grid.gap};
  align-items: center;
  padding-bottom: 2rem;
  @media all and (min-width: ${(props) => props.theme.breakingpoints.lg}) {
    grid-template-columns: 2fr 1fr;
  }
`;

const Link = styled.a`
  white-space: nowrap;
  width: 100%;
  min-width: 14rem;
  box-sizing: border-box;
`;

const ThanxModal = ({
  title,
  subTitle,
  footerText,
}) => (
  <Modal show>
    <ModalIntro>
      {title ? (
        <div>
          <h1>{title}</h1>
        </div>
      ) : (
        <>
          <div>
            <StaticImage
              className="paul"
              src="../images/paul2021.png"
              placeholder="none"
              layout="fixed"
              width={205}
              alt="Paul de Vries"
            />
          </div>
          <div>
            <h1>Bedankt voor je bericht!</h1>
          </div>
        </>
      )}
    </ModalIntro>
    <p>
      {subTitle || ''}
    </p>
    <br />
    <CtaWrapper>
      <div>
        Wil je meer informatie ontvangen of eens rondkijken
        in alle artikelen die ik over de jaren heb geschreven.
      </div>
      <div>
        <Link as={CtaLink} variant="secondary" to="/blog/">Naar blog</Link>
      </div>
    </CtaWrapper>
    <CtaWrapper>
      <div>
        Wil je bijvoorbeeld je kennis al vergroten door het lezen van de vele e-books,
        boeken of een online training volgen?
      </div>
      <div>
        <Link as={CtaOutboundLink} variant="secondary" href="https://shop.dcdw.nl/">Naar webshop</Link>
      </div>
    </CtaWrapper>
    {!footerText && (
      <CtaWrapper>
        <div>
          Direct contact met mij via whatsapp?
        </div>
        <div>
          <Link as={CtaOutboundLink} variant="secondary" href="https://api.whatsapp.com/send?phone=31655841398">Contact opnemen</Link>
        </div>
      </CtaWrapper>
    )}
    {footerText ? (
      <p>{footerText}</p>
    ) : (
      <>
        <p>
          Nogmaals dank voor je bericht!
        </p>
        <h3>Paul de Vries</h3>
      </>
    )}
  </Modal>
);

export default ThanxModal;
